<article class="page-container flex flex-column">
  <section class="flex justify-content-between align-items-center pb-2">
    <span>
      <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.actions.add"
        (click)="openModal()" *ngIf="isCounter">
      </button>
    </span>

    <span class="inline-flex align-items-center">
      <label class="no-margin" for="show-old-turns" [style.margin-right.px]="10">{{screen.actions.seeOldTurns}}</label>
      <p-inputSwitch name="show-old-turns" [(ngModel)]="isOldTurns" validation>
      </p-inputSwitch>
    </span>
  </section>

  <section class="inline-flex flex-column" *ngIf="!isOldTurns">
    <section class="pb-2">
      <p-accordion styleClass="hide-from-medium pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
        collapseIcon="far fa-eye-slash">
        <p-accordionTab class="m-0" [header]="screen.labels.filters">
          <label for="dtMobilePatientFilter">{{screen.labels.patient}}</label>
          <div>
            <input pInputText type="text" name="dtMobilePatientFilter" [(ngModel)]="dtPatientFilter"
              (input)="dt.filter(dtPatientFilter, 'patientName', 'contains')" validation>
          </div>

          <label for="dtMobileSpecialtyFilter" *ngIf="!isDoctor">{{screen.labels.specialty}}</label>
          <div *ngIf="!isDoctor">
            <input pInputText type="text" name="dtMobileSpecialtyFilter" [(ngModel)]="dtSpecialtyFilter"
              (input)="dt.filter(dtSpecialtyFilter, 'specialtyName', 'contains')" validation>
          </div>

          <label for="dtMobileDoctorFilter" *ngIf="isCounter || isVital">{{screen.labels.doctor}}</label>
          <div *ngIf="isCounter || isVital">
            <input pInputText type="text" name="dtMobileDoctorFilter" [(ngModel)]="dtDoctorFilter"
              (input)="dt.filter(dtDoctorFilter, 'doctorName', 'contains')" validation>
          </div>
        </p-accordionTab>
      </p-accordion>
    </section>

    <p-table #dt [value]="turns" [paginator]="true" [loading]="loading" dataKey="id" [rows]="pageSize"
      [contextMenu]="cm" [(contextMenuSelection)]="selectedTurn" (onContextMenuSelect)="onContextMenuSelection()"
      class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="turnNumber" class="hide-on-medium" [style.width.px]="75">
          <col data-id="turnNumber" class="hide-from-medium" [style.width.px]="250">
          <col data-id="patient-age">
          <col data-id="specialty" class="hide-on-medium" [style.width.%]="20" *ngIf="!isDoctor">
          <col data-id="doctor" class="hide-on-medium" [style.width.%]="20" *ngIf="isCounter || isVital">
          <col data-id="actions" class="hide-on-medium" [style.width.px]="70" *ngIf="isVital || isDoctor">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th scope="turn" class="text-center hide-on-medium" rowspan="2">{{screen.labels.turn}}</th>
          <th scope="turn" class="text-center hide-from-medium">{{screen.labels.turn}}</th>
          <th scope="age" class="hide-on-medium">{{screen.labels.patient}} - {{screen.labels.age}}</th>
          <th scope="patient" class="hide-from-medium">{{screen.labels.patient}}</th>
          <th scope="specialty" class="hide-on-medium" *ngIf="!isDoctor">{{screen.labels.specialty}}</th>
          <th scope="doctor" class="hide-on-medium" *ngIf="isCounter || isVital">{{screen.labels.doctor}}</th>
          <th scope="isDoctor" class="hide-on-medium" rowspan="2" *ngIf="isVital || isDoctor"></th>
        </tr>
        <tr class="hide-on-medium">
          <th scope="patient">
            <input pInputText type="text" name="dtPatientFilter" [(ngModel)]="dtPatientFilter"
              (input)="dt.filter(dtPatientFilter, 'patientName', 'contains')">
          </th>
          <th scope="specialty" *ngIf="!isDoctor">
            <input pInputText type="text" name="dtSpecialtyFilter" [(ngModel)]="dtSpecialtyFilter"
              (input)="dt.filter(dtSpecialtyFilter, 'specialtyName', 'contains')">
          </th>
          <th scope="doctor" *ngIf="isCounter || isVital">
            <input pInputText type="text" name="dtDoctorFilter" [(ngModel)]="dtDoctorFilter"
              (input)="dt.filter(dtDoctorFilter, 'doctorName', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-turn>
        <tr [pContextMenuRow]="turn" [class]="turn.turnStatusCodeAlt?.toLowerCase()">
          <td class="text-right cursor-pointer hide-on-medium"
            pTooltip="{{turn.turnDateTime | date : 'hh:mm:ss a'}}<br><br><b>{{screen.labels.status}}</b>: {{turn.turnStatusName}}"
            tooltipPosition="right" [escape]="false">
            {{turn.turnNumber}}
          </td>
          <td class="hide-from-medium p-datatable__vertical-top">
            <div class="form__field">
              <span>
                <span>
                  <b>{{screen.labels.turn}}:</b> {{turn.turnNumber}}
                </span>
                |
                <span>
                  {{turn.turnDateTime | date : 'hh:mm:ss a'}}
                </span>
              </span>
            </div>
            <div class="form__field">
              <span>
                <b>{{screen.labels.status}}:</b> {{turn.turnStatusName}}
              </span>
            </div>
          </td>

          <td>
            {{turn.patientName}}
            <i class="far fa-calendar-check cursor-pointer hide-on-medium"
              pTooltip="{{turn.patientDateBorn | date : 'dd-MM-yyyy' : '+0000'}}{{turn.ageLabel}}"
              *ngIf="turn.patientDateBorn"></i>
            <div class="hide-from-medium form__field"></div>
            <div class="hide-from-medium form__field">
              <span>
                <b>{{screen.labels.age}}</b>: {{turn.patientDateBorn | date : 'dd-MM-yyyy' : '+0000'}}{{turn.ageLabel}}
              </span>
            </div>
            <div class="hide-from-medium form__field" *ngIf="!isDoctor">
              <span>
                <b>{{screen.labels.specialty}}:</b>
                {{turn.specialtyName}}
              </span>
            </div>
            <div class="hide-from-medium form__field" *ngIf="isCounter || isVital">
              <span>
                <b>{{screen.labels.doctor}}:</b>
                {{turn.doctorName}}
              </span>
            </div>
            <div class="hide-from-medium form__field">
              <span>
                <ng-template *ngTemplateOutlet="datatableCurrentActions; context: {$implicit: turn}"></ng-template>
              </span>
            </div>
          </td>

          <td class="text-ellipsis cursor-pointer hide-on-medium" *ngIf="!isDoctor" [pTooltip]="turn.specialtyName"
            tooltipPosition="left">
            {{turn.specialtyName}}
          </td>

          <td class="text-ellipsis cursor-pointer hide-on-medium" *ngIf="isCounter || isVital"
            [pTooltip]="turn.doctorName" tooltipPosition="left">
            {{turn.doctorName}}
          </td>

          <td class="text-right hide-on-medium" *ngIf="isVital || isDoctor">
            <ng-template *ngTemplateOutlet="datatableCurrentActions; context: {$implicit: turn}"></ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" *ngIf="isCounter && !isVital && !isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="5" *ngIf="isCounter && isVital && !isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="4" *ngIf="isCounter && !isVital && isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="4" *ngIf="isCounter && isVital && isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="5" *ngIf="!isCounter && isVital && !isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="4" *ngIf="!isCounter && isVital && isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
          <td colspan="3" *ngIf="!isCounter && !isVital && isDoctor">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="inline-flex flex-column" *ngIf="isOldTurns">
    <section class="hide-from-small pb-2">
      <p-accordion styleClass="hide-from-small pb-2 accordion__tab--no-margin" expandIcon="far fa-eye"
        collapseIcon="far fa-eye-slash">
        <p-accordionTab class="m-0" [header]="screen.labels.filters">
          <label for="dtMobilePatientFilter2">{{screen.labels.document}}</label>
          <div>
            <input pInputText type="text" name="dtMobilePatientFilter2" [(ngModel)]="dtPatientFilter2"
              (input)="dt2.filter(dtPatientFilter, 'patient', 'contains')">
          </div>

          <label for="dtMobileSpecialtyFilter2" *ngIf="!isDoctor">{{screen.labels.specialty}}</label>
          <div *ngIf="!isDoctor">
            <input pInputText type="text" name="dtMobileSpecialtyFilter2" [(ngModel)]="dtSpecialtyFilter2"
              (input)="dt2.filter(dtSpecialtyFilter, 'specialty', 'contains')">
          </div>

          <label for="dtMobileDoctorFilter2" *ngIf="isCounter || isVital">{{screen.labels.specialty}}</label>
          <div *ngIf="isCounter || isVital">
            <input pInputText type="text" name="dtMobileDoctorFilter2" [(ngModel)]="dtDoctorFilter2"
              (input)="dt2.filter(dtDoctorFilter, 'doctor', 'contains')">
          </div>
        </p-accordionTab>
      </p-accordion>
    </section>

    <p-table #dt2 [value]="oldTurns.content" [lazy]="true" (onLazyLoad)="lazyReadOldTurns($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="oldTurns.totalElements" [loading]="loading" dataKey="id" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup class="hide-on-small">
          <col data-id="patient">
          <col data-id="doctor" [style.width.%]="25">
          <col data-id="specialty" [style.width.%]="25">
          <col data-id="age" [style.width.px]="200">
          <col data-id="actions" [style.width.px]="140">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th scope="patient">{{screen.labels.patient}}</th>
          <th scope="doctor">{{screen.labels.doctor}}</th>
          <th scope="specialty">{{screen.labels.specialty}}</th>
          <th scope="date" rowspan="2">{{screen.labels.date}}</th>
          <th scope="action" rowspan="2"></th>
        </tr>
        <tr>
          <th scope="patient">
            <input pInputText type="text" name="dtPatientFilter2" [(ngModel)]="dtPatientFilter2"
              (input)="dt2.filter(dtPatientFilter2, 'patient', 'contains')">
          </th>
          <th scope="doctor">
            <input pInputText type="text" name="dtDoctorFilter2" [(ngModel)]="dtDoctorFilter2"
              (input)="dt2.filter(dtDoctorFilter2, 'doctor', 'contains')">
          </th>
          <th scope="specialty">
            <input pInputText type="text" name="dtSpecialtyFilter2" [(ngModel)]="dtSpecialtyFilter2"
              (input)="dt2.filter(dtSpecialtyFilter2, 'specialty', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-turn>
        <tr>
          <td>{{turn.patientName}}</td>
          <td>{{turn.doctorName}}</td>
          <td>{{turn.specialtyName}}</td>
          <td class="table__status-label">
            {{turn.turnDateTime | date : 'dd-MM-yyyy HH:mm:ss' : '+0000'}}
          </td>
          <td class="text-right">
            <button pButton icon="far fa-file-pdf" class="p-button-info p-button-outlined"
              [pTooltip]="screen.actions.seeHistory" tooltipPosition="left"
              (click)="seeHistory(turn.patientClinicHistory, turn.id, turn.specialtyCodeAlt)" [disabled]="loading">
            </button>

            <button pButton icon="pi pi-list" class="p-button-success p-button-outlined" pTooltip="Ver opciones"
              tooltipPosition="left" (click)="turnActionsPopup.toggle($event)"
              [disabled]="loading || !turn.actions || turn.actions.length === 0" [style.marginLeft.px]="20"
              *ngIf="turn.actions.length > 0">
            </button>

            <p-menu #turnActionsPopup [popup]="true" [model]="turn.actions" appendTo="body"></p-menu>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">
            <ng-template [ngTemplateOutlet]="datatableEmpty"></ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <p-contextMenu #cm [model]="options"></p-contextMenu>

  <ms-pdf-viewer [pdfFile]="historyFile" [(show)]="showHistoryPdf"></ms-pdf-viewer>

  <ms-pdf-viewer [pdfFile]="recipeFile" [(show)]="showRecipePdf"></ms-pdf-viewer>

  <ng-template #datatableCurrentActions let-turn>
    <p-button icon="fas fa-chevron-right" styleClass="p-button-warning p-button-outlined"
      (onClick)="goToConsult(turn, true)" [pTooltip]="screen.actions.care" tooltipPosition="left"
      *ngIf="isVital && turn.turnStatusCodeAlt?.toLowerCase() === 'vital'">
    </p-button>

    <p-button icon="fas fa-chevron-right" styleClass="p-button-success p-button-outlined" (onClick)="goToConsult(turn)"
      [pTooltip]="screen.actions.care" tooltipPosition="left"
      *ngIf="isDoctor && (turn.turnStatusCodeAlt?.toLowerCase() === 'waiting' || turn.turnStatusCodeAlt?.toLowerCase() === 'in-progress')">
    </p-button>
  </ng-template>

  <ng-template #datatableEmpty>
    <span>{{screen.labels.emptyTable}}</span>
  </ng-template>
</article>